import { ref } from 'vue';
import { updateApplicationDetail } from '../api/updateApplicationDetail';
import { handleUpdateApplicationError } from '../lib/handleUpdateApplicationError';
import type { UpdateApplicationDetailRequest } from './types';

/**
 * 管理者向け申込更新カスタムフック
 *
 * 配送ステータスが「受け渡し済み」以外の場合のみ更新可能
 */
export const useUpdateApplicationDetail = () => {
    const isLoading = ref(false);
    const error = ref<string | null>(null);

    /**
     * 申込情報を更新する
     *
     * @param applicationId 申込ID
     * @param request 更新リクエスト
     * @returns 成功時はtrue、失敗時はfalse
     */
    const update = async (applicationId: string, request: UpdateApplicationDetailRequest): Promise<boolean> => {
        isLoading.value = true;
        error.value = null;

        try {
            await updateApplicationDetail(applicationId, request);
            return true;
        } catch (caughtError: unknown) {
            error.value = handleUpdateApplicationError(caughtError);
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    /**
     * エラーをクリアする
     */
    const clearError = () => {
        error.value = null;
    };

    return {
        isLoading,
        error,
        update,
        clearError,
    };
};
